/**
 * ハンバーガーメニュー
 */
import lenis from './lenis.js';
jQuery( function ($) {

  const hamburger = $( '.js-hamburger' );
  const drawer    = $( '.js-drawer' );
  const focusTrap = $( '.js-focus-trap' );
  const drawerInner  = $( '.p-drawer__inner' );

  drawerInner.on( 'wheel touchmove' ,(e) => {
    e.stopPropagation()
  })

  // クリックで開閉
  hamburger.on( 'click', function () {
    const thisHamburger = $( this );
    if ( 'false' === $(this).attr('aria-expanded') ) {
      openDrawer( thisHamburger );
    } else {
      closeDrawer( thisHamburger );
    }
  });

  // リサイズ時の処理
  let flag;
  if ( window.matchMedia('(min-width: 1000px)').matches ) {
    flag = 'pc';
  } else {
    flag = 'sp';
  }
  $( window ).on( 'resize', function () {
    if ( window.matchMedia( '( min-width: 1000px )' ).matches && flag !== 'pc' ) {
      closeDrawer( hamburger );
      flag = 'pc';
    } else if ( flag !== 'sp' ) {
      closeDrawer( hamburger );
      flag = 'sp';
    }
  });

  const openDrawer = ( thisHamburger ) => {
    drawer.fadeIn().attr( 'aria-hidden', 'false' ).focus();
    lenis.stop();
    thisHamburger.attr( 'aria-expanded', 'true' );
    thisHamburger.attr( 'aria-label', '閉じる' );
    thisHamburger.children('span').text('閉じる');
  }

  const closeDrawer = ( thisHamburger ) => {
    drawer.fadeOut().attr( 'aria-hidden', 'true' ).blur();
    thisHamburger.attr( 'aria-expanded', 'false' );
    thisHamburger.attr( 'aria-label', 'メニューを開く' );
    thisHamburger.children('span').text('メニュー');
    lenis.start();
    hamburger.focus();
  }

  // フォーカストラップ制御
  focusTrap.on( 'focus', function() {
    hamburger.focus();
  } );

  $( document ).on( 'keydown', function( e ) {
    if ( e.key === 'Escape' ) {
      closeDrawer( hamburger );
    }
  } );
});
